import { Meta } from '@angular/platform-browser';

const FB_APP_ID_SELECTOR = 'property="fb:app_id"';

export function upsertFacebookAppId(meta: Meta, appId: string | undefined | null): void {
  const normalized = appId?.trim();
  if (!normalized) {
    return;
  }

  const existing = meta.getTag(FB_APP_ID_SELECTOR);
  if (existing) {
    meta.updateTag({ property: 'fb:app_id', content: normalized });
    return;
  }

  meta.addTag({ property: 'fb:app_id', content: normalized });
}
